export const CACHE_TTL_60MIN = 1000 * 60 * 60
export const CACHE_TTL_DEFAULT = CACHE_TTL_60MIN
